import { Controller } from 'react-hook-form';
import { Col, Input, Label } from 'reactstrap';

function EmergencyContact({ isView = false, control, errors }) {
  return (
    <div className="new-travel-request-card p-3 bg-white">
      <div className="fw-semibold mb-2 fs-5">Emergency Contact</div>
      <div className="d-flex flex-row justify-content-between gap-3">
        <Col>
          <Label>
            Contact Name<span className="text-danger">*</span>
          </Label>
          <Controller
            control={control}
            name="contactName"
            render={({ field }) => (
              <>
                <Input
                  {...field}
                  type="text"
                  placeholder="Contact Name"
                  className="external-filter-input"
                  title="Provide the full name of the person to be contacted in case of emergency."
                  disabled={isView}
                />
                {errors.contactName && (
                  <div className="text-danger">
                    {errors.contactName.message}
                  </div>
                )}
              </>
            )}
          />
        </Col>
        <Col>
          <Label>
            Contact Number<span className="text-danger">*</span>
          </Label>
          <Controller
            control={control}
            name="contactNumber"
            rules={{ required: 'Contact Number is required' }}
            render={({ field }) => (
              <>
                <Input
                  {...field}
                  type="text"
                  placeholder="Contact Number"
                  className="external-filter-input"
                  title="Enter a reachable phone number for the emergency contact person."
                  disabled={isView}
                />
                {errors.contactNumber && (
                  <div className="text-danger">
                    {errors.contactNumber.message}
                  </div>
                )}
              </>
            )}
          />
        </Col>
        <Col>
          <Label>Comments</Label>
          <Controller
            control={control}
            name="contactComments"
            render={({ field }) => (
              <Input
                {...field}
                type="text"
                placeholder="Comments"
                className="external-filter-input"
                title="Add any notes or special instructions related to the emergency contact."
                disabled={isView}
              />
            )}
          />
        </Col>
      </div>
    </div>
  );
}

export default EmergencyContact;
